<template>
  <div class="leftMenu">
      <div class="itemC">
          <div class="itemTtl">快速通道</div>
          <ul>
              <li><router-link to="/submission">论文投稿</router-link></li>
              <li><router-link to="/meetingRegist">参会注册</router-link></li> 
          </ul>
      </div>
      <!-- <div class="itemC">
          <div class="itemTtl">联系我们</div>
          <div class="cont">
            <span>唐老师 屈老师</span><br>
            <span>010-82544542</span><br>
            <span>010-82544542</span><br>
            <span>caa@ia.ac.cn</span>
          </div>
      </div> -->


  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@media screen and(max-width: 679px){
  .leftMenu{
    display: none;
  }
}
@media screen and(min-width: 680px) and (max-width: 1079px){
  .leftMenu{
    display: none;
  }
}
@media screen and (min-width: 1080px){
  .leftMenu{
    width: 200px;
    background-color: #fff;
    border-radius: 2px;
    position: absolute;
    margin-top: 40px;
    .itemC{
      position: relative;
      margin-bottom: 40px;
      text-align: center;
      background-color: #f1f1fa;
      font-size: 16px;
      padding:0 20px 20px;
      .itemTtl{
        width:100px ;
        background-color: #3c3e99;
        border-radius:0 0  10px 10px;
        color:#fff;
        line-height: 40px;
        margin:0 auto;

      }
      .cont{
        color: #666;
        font-size: 14px;
        line-height: 30px;
        padding:40px 0;
      }
      ul{
        margin-top: 20px;
        color:#666;
        font-size: 18px;
        li{
          list-style: none;
          line-height: 40px;
        }
        li:not(:last-child){
          border-bottom: 1px dashed #ccc;

        }
        a{
          color: #666;
          text-decoration: none;
        }
      }
    }
    
  }
}

</style>
